const FILES_PATH = '/files/';
const DOCUMENTS_PATH = '/files/documents/';
const CLIENT_PARAM = 'c';
const FAILURE_PARAM = 'fallback';
const MARK = '1';
const STATUS_SERVER_MIN = 500;

const withParam = (url, name) => {
    const link = new URL(url, window.location.href);
    link.searchParams.set(name, MARK);
    return link.toString();
};

const pathStartsWith = (url, path) => new URL(url, window.location.href).pathname.startsWith(path);

export const withFailureMark = (url) => (pathStartsWith(url, FILES_PATH) ? withParam(url, FAILURE_PARAM) : url);

const isDocumentLink = (url) => pathStartsWith(url, DOCUMENTS_PATH);

export const withClientMark = (url, isCustomer) => (isCustomer && isDocumentLink(url) ? withParam(url, CLIENT_PARAM) : url);

export const isRetryableStatus = (status) => !status || status >= STATUS_SERVER_MIN;
